import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import TextInput from "@builder/components/general/TextInput";
import Toggle from "@builder/components/general/Toggle";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

const CustomSale = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [isFixed, setFixed] = useState(actionStep?.action?.data.isFixed || false);
    const [customSaleLabel, setCustomSaleLabel] = useState<string>(actionStep?.action?.data.customSaleLabel || "");
    const [customSaleAmount, setCustomSaleAmount] = useState<string>(actionStep?.action?.data.customSaleAmount || "");
    const [applyTaxes, setApplyTaxes] = useState<boolean>(actionStep?.action?.data.applyTaxes || false);
    const dispatch = useAppDispatch();

    const handleAmount = (value: string) => {
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            setCustomSaleAmount(value);
        }
    };

    useEffect(() => {
        const data = isFixed ? { customSaleAmount, customSaleLabel, applyTaxes } : undefined;
        const action = {
            type: isFixed ? ActionType.ADD_CUSTOM_SALE : ActionType.SHOW_ADD_CUSTOM_SALE_UI,
            data: { isFixed, ...data }
        };

        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, isFixed, customSaleAmount, customSaleLabel, applyTaxes]);

    return (
        <div className="function-add-cart-note-wrapper">
            <OliverText
                text="How do you want to add the custom sale and label?"
                size="xs"
                weight="medium-heavy"
                translatePrefix="popup.actionBuilder."
            />
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => setFixed(false)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Open custom sale dialog box" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText
                            text="Manually add the custom sale during checkout"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={!isFixed} label="" value="" custom={false} />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => setFixed(true)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText
                            text="Add a fixed custom sale to the cart"
                            size="xs"
                            weight="medium-heavy"
                            translatePrefix="popup.actionBuilder."
                        />
                        <OliverText
                            text="Preconfigure a custom sale to add each time"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={isFixed} label="" value="" custom={false} />
                </div>
                {isFixed ? (
                    <>
                        <div className="function-add-cart-note-wrapper">
                            <TextInput callback={setCustomSaleLabel} value={customSaleLabel} className="actions-tab-input" placeholder="Label" />
                            <TextInput
                                callback={handleAmount}
                                value={customSaleAmount}
                                className="actions-tab-input"
                                placeholder="Price"
                                icon={{
                                    src: ["./dollar-sign.svg"]
                                }}
                            />
                        </div>
                        <div className="function-checkbox-wrapper">
                            <div className="function-checkbox-label-wrapper">
                                <OliverText text="Apply taxes" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                                <OliverText
                                    text="Fixed custom sales use the outlet default tax rates"
                                    size="xs"
                                    weight="light"
                                    translatePrefix="popup.actionBuilder."
                                />
                            </div>
                            <div style={{ width: "fit-content" }}>
                                <Toggle callback={() => setApplyTaxes(prev => !prev)} checked={applyTaxes} label="" />
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default CustomSale;
